export default {
  HOTLINE: '0123456789',
  APP_TITLE: process.env.VUE_APP_TITLE,
  APP_LOGO_TITLE: process.env.VUE_APP_LOGO_TITLE,
  APP_MENUS: process.env.VUE_APP_MENUS,
  USER_ROLE_KEYS: process.env.VUE_APP_USER_ROLES,
  EDITOR_API_KEY: '1oo1lu0sbcnrznvh20hr6tatwezj2zflplh17eataa0p4kft',
  GOOGLE_API_KEY: 'ULQe0gEWUf1eXx7tGsTeBjd_TXzVsYIiake4y1OHKWE'
}
